
<template>
  <!--添加单元-->
  <x-addEdit
    ref="addEdit"
    :initReqHandle="false"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="gps" slot-scope="{formItem}">
      <x-location
        ref="location"
        :form="$children[0].form"
        :inputKey="inputKey"
        :position="position"
        :lngLat="lngLat"
        :locationData="formItem">
      </x-location>
    </template>
  </x-addEdit>
</template>

<script>
import {fetchSelect, userRange} from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [addEdit, fetchSelect, userRange],
  name: 'addUnit',
  data () {
    let decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      lng: {
        validateTrigger: 'blur',
        rules: [{ required: true, message: '请定位经度' }]
      },
      lat: {
        validateTrigger: 'blur',
        rules: [{ required: true, message: '请定位纬度' }]
      },
      buildingId: {
        rules: [
          { required: true, message: '请选择楼栋' }
        ]
      },
      standardAddress: {
        rules: [
          {pattern: this.REG.addressName, message: this.MESSAGE.addressName}
        ]
      },
      title: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入单元名称' },
          { pattern: this.REG.name, message: '单元名称为2-20位汉字、字母、数字' }
        ]
      },
      unitNo: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入单元编号' },
          { min: 1, max: 2, message: '单元名称为1-2个字' }
        ]
      }
    };
    return {
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'lng',
        lat: 'lat',
        address: 'no_address'
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属小区',
          fetchOptions: this.getOptions,
          handle: (e) => {
            this.communityChange(2, e, 'formList'); this.communitySelected(e);
            this.$refs.addEdit.resetSubValue(['buildingId']);
          }, // 触发获取楼栋
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['lng', decoratorOptions.lng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['lat', decoratorOptions.lat]
            }
          ]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          placeholder: '请选择楼栋',
          props: ['buildingId', decoratorOptions.buildingId]
        },
        {
          label: '标准地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入省市区街道和门牌上的道路名',
          props: ['standardAddress', decoratorOptions.standardAddress]
        },
        {
          label: '名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入单元名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '单元编号',
          inputType: 'input',
          options: [],
          placeholder: '请输入单元编号',
          type: 'number',
          props: ['unitNo', decoratorOptions.unitNo]
        }
      ],
      formKey: {
        communityId: '',
        lng: '',
        lat: '',
        buildingId: '',
        standardAddress: '',
        title: '',
        unitNo: ''
      },
      addParam: {
        url: '/units',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/units/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/units/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    // this.communitySelect(0, 'formList', 1).then(() => {
    //   this.$route.query.id && this.$refs.addEdit.getDetail();
    // });
    this.communitySelectByStep(1, undefined, undefined, '0').then(() => {
      this.$route.query.id && this.$refs.addEdit.getDetail();
    });
  },
  methods: {
    getOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, 0, item.communityId);
    },

    /** 给GPS预定位 设置城市 */
    communitySelected (val) {
      this.formList[0].communityId = val;
      if (!val) { return; }
      console.log('unit $refs: ', this.$refs.location);
      this.$refs.location && this.$refs.location.positionChanged();
      let label = this.formList[0].options.filter(ele => ele.value === val);
      let labelArr = label[0] && label[0].label.split('/')[0].split(' ');
      let isCity = labelArr && this.$store.state.citys.some(el => el === labelArr[0]);
      isCity ? this.position = labelArr[0] : this.position = labelArr && labelArr[1] || '';
      console.log('label: ', this.position, labelArr);
    },
    detailResHandle (data) {
      let arr = this.formList[0].options;
      let isExit = arr.some(item => item.value == data.communityId);
      if (!isExit) {
        this.$get({
          url: '/community/treeselect/page',
          params: {communityId: data.communityId}
        }).then(({data}) => {
          arr.unshift(data.rows[0]);
        });
      }

      if (data.lng && data.lat) {
        let lng = parseFloat(data.lng);
        let lat = parseFloat(data.lat);
        lng !== 0 && lat !== 0 && (this.lngLat = [lng, lat]);
      }

      this.limitEdit(data, ['communityId', 'buildingId']);
      if (data.communityId) {
        this.communityChange(2, data.communityId, 'formList');
        this.communitySelected(data.communityId);
      }
      this.formList[0].communityId = data.communityId;

      return {};
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
